import { z } from 'zod';
import { paginationFiltersSchema } from 'utils/schemas';
import { supplierStatuses } from './suppliers.types';

export const suppliersFiltersSchema = z
  .object({
    status: z.enum(supplierStatuses).nullable().catch(null),
    name: z.string().catch(''),
    systemName: z.string().catch(''),
  })
  .merge(paginationFiltersSchema);
